import { formatDate } from '../../../../base/utils/dataHelper'

/**
 * `InputCampaign type='date'` alanlarının değeri. Başlangıçta `Date`, kullanıcı elle
 * yazmaya başladığında input'un verdiği ham `string` olur.
 *
 * Ham string saklamak zorunlu: `onChange`'de `new Date(e.target.value)` yapılırsa
 * kullanıcı tarihi yazarken oluşan ara değerler (ör. "2026-0") geçersiz `Date` üretir
 * ve alan ekranda sıfırlanır. Bu yüzden değer olduğu gibi tutulur, `Date`'e yalnızca
 * API'ye gönderirken çevrilir.
 */
export type DateInputValue = Date | string

/** `InputCampaign`'in `value` alanı için yyyy-MM-dd. Geçersiz değerde boş string döner. */
export const toDateInputValue = (value: DateInputValue): string => {
  if (typeof value === 'string') return value

  if (!(value instanceof Date) || isNaN(value.getTime())) return ''

  return value
    .toLocaleString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit' })
    .replace(' ', 'T')
}

/** Değeri `Date`'e çevirir; ayrıştırılamazsa `undefined` döner. */
export const toDateOrUndefined = (value: DateInputValue): Date | undefined => {
  const date = typeof value === 'string' ? new Date(value) : value

  if (!(date instanceof Date) || isNaN(date.getTime())) return undefined

  return date
}

/** Backend filtresine gönderilecek yyyyMMdd. Geçersiz değerde boş string döner. */
export const toApiDate = (value: DateInputValue): string => {
  const date = toDateOrUndefined(value)

  return date ? formatDate(date) : ''
}

/** Filtre öncesi tarih doğrulaması. Geçerliyse `null`, değilse gösterilecek uyarı döner. */
export const validateDateRange = (start: DateInputValue, end: DateInputValue): string | null => {
  const startDate = toDateOrUndefined(start)
  const endDate = toDateOrUndefined(end)

  if (!startDate) return 'Başlangıç tarihi geçersiz.'
  if (!endDate) return 'Bitiş tarihi geçersiz.'
  if (startDate > endDate) return 'Başlangıç tarihi bitiş tarihinden sonra olamaz.'

  return null
}
